// Copyright © 2021 Move Closer
import { MappingTypes } from '@movecloser/front-core';
export const cardAdapterMap = {
    expireAt: 'expire_at',
    isActive: {
        type: MappingTypes.Function,
        value: item => item.is_active === 1
    }
};
